import React from 'react';
import { Icon } from '@/components/ui/Icon';
import { useT, type LabelKey } from '@/i18n/labels';
import type { SessionState } from '@/types';

interface BadgeDef {
  cls: string;
  icon: string;
  key: LabelKey;
}

/**
 * Lifecycle state → badge. The UI SessionState is the 4-value enum
 * (AI_HANDLING/CONSULTATION_REQUESTED/HUMAN_TAKEOVER/CLOSED); the backend's
 * NEW folds into AI_HANDLING (the "New" distinction lives on the ADR-017
 * Category the inbox groups by). Design vocabulary from ac-home.jsx STATE_BADGE.
 */
const STATE_BADGE: Record<SessionState, BadgeDef> = {
  AI_HANDLING: { cls: 'ai', icon: 'bot', key: 'st_ai' },
  CONSULTATION_REQUESTED: { cls: 'consult', icon: 'sparkle', key: 'st_consult' },
  HUMAN_TAKEOVER: { cls: 'takeover', icon: 'takeover', key: 'st_takeover' },
  CLOSED: { cls: 'closed', icon: 'check', key: 'st_closed' },
};

export const StateBadge: React.FC<{ state: SessionState }> = ({ state }) => {
  const { t } = useT();
  const b = STATE_BADGE[state];
  if (!b) return null;
  return (
    <span className={'ac-badge ' + b.cls} data-testid={`state-badge-${state}`}>
      <Icon name={b.icon} size={12} stroke={2.2} />
      {t(b.key)}
    </span>
  );
};
